module.exports = __webpack_public_path__ + "static/media/history.d9aee92e.jpg";